import React from "react";
import { useSmartFilters } from "./useSmartFilters";
import { SmartFilter } from "./SmartFilter";
import { useReactiveVar } from "@apollo/client";
import { filterStateVar } from "@/reactiveVars/organization";
import { SmartFiltersSkeleton } from "./SmartFilterSkeleton";
import { CarouselArrows } from "./CarouselArrows";
import { CarouselItem, Carousel, CarouselContent } from "@/components/ui";

export const SmartFilters = () => {
  const { smartFilters, loading } = useSmartFilters();
  const filterState = useReactiveVar(filterStateVar);

  if (loading)
    return (
      <div className="min-w-0 overflow-hidden">
        <SmartFiltersSkeleton />
      </div>
    );

  return (
    <div className="min-w-0">
      <Carousel opts={{ slidesToScroll: "auto" }}>
        <CarouselContent className="-ml-2">
          {smartFilters?.map((sf) => (
            <CarouselItem className={"basis-auto pl-2"} key={sf.id}>
              <SmartFilter smartFilter={sf} filterState={filterState} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselArrows />
      </Carousel>
    </div>
  );
};
